import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Selectors from '../selectors';
import Actions from '../action';

import { ViewAffiliatePresentational } from './view-affiliate-presentational';
import { useParams } from 'react-router-dom';

const ViewAffiliateFunctional = ({ history, affiliateByIDLoading, getAffiliateByID, affiliateByIDData }) => {
	const { id } = useParams();
	useEffect(() => {
		getAffiliateByID(id);
	}, []);
	return <ViewAffiliatePresentational history={history} affiliateByIDLoading={affiliateByIDLoading} affiliateByIDData={affiliateByIDData} />;
};

const mapStateToProps = (state) => {
	return {
		affiliateByIDLoading: Selectors.affiliateByIDLoading(state),
		affiliateByIDData: Selectors.affiliateByIDData(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getAffiliateByID: (id, history) => dispatch(Actions.creators.getAffiliateByID(id, history)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(ViewAffiliateFunctional);

export default Connected;
